module.exports = __webpack_public_path__ + "static/media/montblanc-cillian-walking.f89434a5.gif";